import {Component} from '@angular/core';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DataGrid} from '../../DoraData/data-grid';
import {DataType} from '../../pusblisher/ipublisher';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {DataRow} from '../../DoraData/data-row';
import {DoraProperty} from '../../Decorators/Decorator';

@Component({
  selector: 'dora-widget-base-grid',
  template: ''
})
/**
 * Base Widget for components that read grid from publisher.
 * gridId is id of Grid to read. If necessary you can set gridIdPostfix string on onInit().
 * This string is added to gridId.
 * When data raise (DataGrid type) it is stored onto dataGrid parameter and onNewData() is called
 * Manage Message <b>MessageGridSelected</B>
 */
export class WidgetBaseGridComponent extends WidgetBaseComponent {
  @DoraProperty
  protected gridId = '';

  @DoraProperty
  protected disableMessageGridSelected = false;

  protected dataGrid: DataGrid;
  protected gridIdPostfix = ''; // Optional. This is added to gridId to build id code

  protected flSelectFirstRow = true;

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.readData();

    if (this.disableMessageGridSelected === false) {
      this.messageService.getMessage(this.EventChannel, MessageGridSelected, this.CallerName).subscribe(message => {
        this.gridId = (message.data as MessageGridSelected).idGrid + this.gridIdPostfix;

        this.readData();
      });
    }
  }

  protected readData(): void {
    if (this.gridId === null || this.gridId === '') {
      return;
    }
    // Read Preselect table
    this.read([this.gridId], DataType.GRID).subscribe((data: any) => {
      if (data !== null) {
        this.dataGrid = (data as DataGrid);

        this.onNewData();
      }
    });
  }

  /**
   * Received new <b>data</b>
   */
  protected onNewData(): void {
    // select first row if required
    if (this.flSelectFirstRow) {
      if (this.dataGrid !== undefined && this.dataGrid.DataRows.length > 0) {
        this.selectedGrid(this.dataGrid.DataRows[0].Id);
      }
    }
  }

  protected selectedGrid(rowId: string): void {
  }

}
